import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';

import { organizationsApi } from '../api/organizations-api';

import { organizationKeys } from './organization-keys';

export interface SupportSessionFilter {
  organizationId?: string;
  /** Only live sessions (true), only ended or expired ones (false), or both. */
  active?: boolean;
}

const PAGE_SIZE = 20;

export function supportSessionsQueryOptions(filter: SupportSessionFilter) {
  return infiniteQueryOptions({
    queryKey: organizationKeys.supportSessionList(filter),
    queryFn: ({ pageParam }) =>
      organizationsApi.supportSessions({
        limit: PAGE_SIZE,
        ...filter,
        ...(pageParam ? { cursor: pageParam } : {}),
      }),
    initialPageParam: null as string | null,
    getNextPageParam: (page) => page.nextCursor,
  });
}

/** Newest first; "Load more" follows nextCursor. Sessions lapse on their own after 60 minutes. */
export function useSupportSessions(filter: SupportSessionFilter) {
  return useInfiniteQuery({ ...supportSessionsQueryOptions(filter), refetchInterval: 60_000 });
}
